// eslint-disable-next-line import/prefer-default-export
export const SET_APP_LANGUAGE = 'APP::SET_APP_LANGUAGE';
